import { Fragment } from 'react';
import { CloseIcon } from 'assets/images/CloseIcon/CloseIcon';
import { PendingIcon } from 'assets/images/PendingIcon/PendingIcon';
import { Divider } from 'components/common/Divider/Divider';
import { Button, Modal, Row, Col } from 'react-bootstrap';
import _ from 'lodash';

const TimesheetErrorVendorModal = props => {
  const {
    onShow,
    onHide,
    handleTimesheetStatus,
    approveTimesheetError,
    approveCircuitMileageError,
    approveHrsAndDollarsError,
  } = props;

  function getValidationMessage() {
    if (approveTimesheetError) {
      return 'Accounting validation error. Timesheet will be sent to AEP for review';
    } else if (approveCircuitMileageError) {
      return 'Circuit Miles validation error. Timesheet will be sent to AEP for review';
    } else if (approveHrsAndDollarsError) {
      return 'PO remaining balance validation error. Timesheet will be sent to AEP for review';
    } else {
      return 'Error occured';
    }
  }

  return (
    <Modal
      show={onShow}
      onHide={onHide}
      size="lg"
      dialogClassName="timesheetErrorDialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton={false}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            width: '100%',
            height: '26px',
          }}
        >
          <div className="pendingIcon">
            <PendingIcon />
          </div>
          Acceptance complete!
          <div
            style={{ marginLeft: 'auto', cursor: 'pointer' }}
            onClick={onHide}
          >
            <CloseIcon />
          </div>
        </div>
      </Modal.Header>
      <Divider />
      <Modal.Body className="psValidationModalBody">
        <div style={{ fontSize: '20px', marginBottom: '24px' }}>
          {getValidationMessage()}
        </div>

        <div className="btnArea">
          <Fragment>
            {approveTimesheetError && (
              <Button
                variant="primary"
                onClick={() => handleTimesheetStatus('transferTimesheetToAEP')}
              >
                Continue
              </Button>
            )}
            <Button variant="secondary" onClick={onHide}>
              Cancel
            </Button>
          </Fragment>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export { TimesheetErrorVendorModal };
